import { Component, OnInit } from '@angular/core';
import { Rebate } from '../../../../classes/Rebate';
import { Supplier } from '../../../../classes/Supplier';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-add-rebate',
  templateUrl: './add-rebate.component.html',
  styleUrls: ['./add-rebate.component.scss']
})
export class AddRebateComponent implements OnInit {

  isSubmitButtonDisabled: boolean = false;
  newRebate: Rebate = new Rebate( );
  availableRoles: string[] = [ 'admin', 'installer' ];
  isAvailable: boolean = true;
  suppliersList: Supplier[] = [];

  rebatePDFName: string = '';

  selectParams: any = {
    id: 'inputSupplier',
    isRequired: true,
    change: ( event ) => { this.newRebate.supplier_id = event.value; },
    options: [ { text: '', value: '' } ]
  };

  constructor ( 
    private model: ModelService,
    public global: GlobalService,
    private alerts: AlertsService,
    private loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Add Rebate/Incentive' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) { 

    this.model.getSuppliersData( ( data ) => {
      this.suppliersList = data;
      this.selectParams.options = [ { text: '', value: '' } ];
      data.forEach( _sp => { this.selectParams.options.push( { text: _sp.name, value: _sp.id } ); });
    }, { 'sorting': 'name' });
  }


  changePDF ( $event ) {

    let file: any = $event.target.files[0];

    if ( !file ) return;

    this.global.showPreloader( );
    let formData = new FormData( );
    formData.append( 'pdf', file, file.fileName );
    this.model.uploadRebatesPDF( formData, file.fileName, ( response ) => {
      this.newRebate.PDF = response.url;
      this.rebatePDFName = response.url.substring(response.url.lastIndexOf('/')+1);
      this.global.hidePreloader( );
    });
  }

  successCallback ( ) {
    this.global.defaultSuccessMessage({ 
      html: 'New rebate/incentive has been added successfully', 
      redirect: '/rebates-list' 
    });
  }


  errorCallback ( message?: string ) {
    let data = {
      messageType: 'error',
      message: message || 'We got some error here...',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.isSubmitButtonDisabled = false;
  }

  submitForm ( ) {

    this.isSubmitButtonDisabled = true;
    this.model.addRebate( this.newRebate, ( response ) => {

      let _answer = response.json( ).answer;
      
      if ( _answer == 'success' ) this.successCallback( );
      else if ( _answer == 'exists' ) {
        this.errorCallback( 'Rebate/Incentive with name "' + this.newRebate.name + '" already exists' );
        this.global.defaultErrorCallback( 'Rebate/Incentive with name "' + this.newRebate.name + '" already exists' );
      } else {
        this.errorCallback( _answer );
        this.global.defaultErrorCallback( _answer );
      }
    });
    return false;
  }

  cancelSubmit ( ) {
    this.global.redirect( '/rebates-list' );
  }
}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/rebates/add-rebate/add-rebate.component.ts